import { Typography } from "@mui/material";

type Props = {
  content: string;
};

const Content = ({ content }: Props) => {
  return (
    <Typography variant="body2" p={{ xs: 1, md: 2 }} align="justify">
      {content}
    </Typography>
  );
};

export default Content;
